module.exports = __webpack_public_path__ + "static/media/soeuae.8c8e055e.jpg";